'use client';

import { createContext, useCallback, useContext, useMemo, useRef, type ReactNode } from 'react';

type NavTourControlValue = {
  restart: () => void;
  registerRestart: (fn: (() => void) | null) => void;
};

const NavTourControlContext = createContext<NavTourControlValue>({
  restart: () => {},
  registerRestart: () => {},
});

export function NavTourControlProvider({ children }: { children: ReactNode }) {
  const restartRef = useRef<(() => void) | null>(null);
  const registerRestart = useCallback((fn: (() => void) | null) => {
    restartRef.current = fn;
  }, []);
  const restart = useCallback(() => {
    restartRef.current?.();
  }, []);
  const value = useMemo(() => ({ restart, registerRestart }), [restart, registerRestart]);
  return <NavTourControlContext.Provider value={value}>{children}</NavTourControlContext.Provider>;
}

/** Settings / UI: only the restart action (ISP). */
export function useNavTourRestart(): () => void {
  return useContext(NavTourControlContext).restart;
}

/** Coach: register the restart implementation (DIP). */
export function useRegisterNavTourRestart(): (fn: (() => void) | null) => void {
  return useContext(NavTourControlContext).registerRestart;
}
